import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const EServiceSetting: FormizoSchema[] = [
  {
    label: "Can't Answer Times",
    name: "EServiceDoc.Config.Threshold",
    variant: "outlined",
    format: "number",
  },
  {
    header: "TC",
  },
  {
    label: "Text",
    name: "EServiceDoc.Config.Message.TC.Text",
    variant: "outlined",
    format: "textarea",
    rows: 3,
  },
  {
    label: "URL",
    name: "EServiceDoc.Config.Message.TC.URL",
    variant: "outlined",
    format: "text",
  },
  {
    header: "SC",
  },
  {
    label: "Text",
    name: "EServiceDoc.Config.Message.SC.Text",
    variant: "outlined",
    format: "textarea",
    rows: 3,
  },
  {
    label: "URL",
    name: "EServiceDoc.Config.Message.SC.URL",
    variant: "outlined",
    format: "text",
  },
  {
    header: "EN",
  },
  {
    label: "Text",
    name: "EServiceDoc.Config.Message.EN.Text",
    variant: "outlined",
    format: "textarea",
    rows: 3,
  },
  {
    label: "URL",
    name: "EServiceDoc.Config.Message.EN.URL",
    variant: "outlined",
    format: "text",
  },
];
